import { undefinedObjectToNull } from '@shared/api/middleware/mappingAPI/helpers'
import { TypeMappingFavoritesGQLOutput } from '@shared/api/middleware/mappingAPI/gql_favorites/type'

export const mappingFavoritesGQL = (object: any): TypeMappingFavoritesGQLOutput => {
  const result = {
    restaurants: {},
    selections: {},
    concerts: {},
    news: {},

    performances: {},
    exhibitions: {},
    movies: {},
    sports: {},
  }

  try {
    const favorites = object.user.activity.favorites.items

    const typeMap = {
      restaurant: 'restaurants',
      selection: 'selections',
      concert: 'concerts',
      article: 'news',

      performance: 'performances',
      exhibition: 'exhibitions',
      movie: 'movies',
      sport: 'sports',
    }

    favorites.forEach((item) => {
      const { id: idSubject, name: nameSubject } = item.subject
      const lowerId = idSubject.toLowerCase()

      Object.keys(typeMap).forEach((type) => {
        if (lowerId.includes(type)) {
          result[typeMap[type]][parseInt(idSubject.match(/\d+/))] = nameSubject || true
        }
      })
    })

    return undefinedObjectToNull(result)
  } catch (error) {
    console.error(error)
    return result
  }
}
